<template>
    <div class="body-container">
        <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
            <b-spinner
                variant="dark"
                label="Spinning"
                class="login-loader"
            ></b-spinner>
        </div>
        <b-form @submit="onSubmit" v-if="!loading">
            <!--<b-form-group :label="$t('text.username')">
                <b-form-input
                disabled
                v-model="user.username"
                required
                ></b-form-input>
            </b-form-group>-->

            <b-form-group id="input-group-3" :label="$t('text.email_address')" label-for="input-3">
                <b-form-input
                disabled
                id="input-3"
                v-model="user.email"
                type="email"
                :placeholder="$t('text.enter_email')"
                required
                ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-1" :label="$t('text.first_name')" label-for="input-1">
                <b-form-input
                :disabled="!editEnabled"
                id="input-1"
                v-model="user.first_name"
                :placeholder="$t('text.enter_first_name')"
                required
                ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" :label="$t('text.last_name')" label-for="input-2">
                <b-form-input
                :disabled="!editEnabled"
                id="input-2"
                v-model="user.last_name"
                :placeholder="$t('text.enter_last_name')"
                required
                ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-4" :label="$t('text.phone')" label-for="input-4">
                <b-form-input
                :disabled="!editEnabled"
                id="input-4"
                v-model="user.phone"
                type="number"
                :placeholder="$t('text.enter_phone')"
                required
                ></b-form-input>
            </b-form-group>
                                
            <b-form-group v-if="editEnabled" id="input-group-5" :label="$t('text.new_password') + ' (' + $t('text.optional') + ')'" label-for="input-4">
                <b-form-input
                id="input-5"
                v-model="form.password"
                type="password"
                :placeholder="$t('text.enter_password')"
                ></b-form-input>
            </b-form-group>

            <b-form-group v-if="editEnabled" id="input-group-6" :label="$t('text.repeat_password') + ' (' + $t('text.optional') + ')'" label-for="input-4">
                <b-form-input
                id="input-6"
                v-model="form.repeat_password"
                type="password"
                :placeholder="$t('text.repeat_password')"
                ></b-form-input>
                <b-form-invalid-feedback :state="passwordValidation">
                    {{ $t('text.passwords_not_match') }}
                </b-form-invalid-feedback>
            </b-form-group>

            <b-button v-if="!editEnabled" type="submit" variant="primary">{{ $t('text.edit_profile') }}</b-button>
            <b-button v-if="editEnabled" :disabled="!enableSubmitButton" type="submit" variant="primary">{{ $t('text.save') }}</b-button>
            <a v-if="editEnabled" class="link-button" @click="editEnabled=false"> {{ $t('text.cancel') }}</a>
            <b-button v-if="editEnabled" class="submit-button" @click="deleteUser()" variant="danger">{{ $t('text.delete') }}</b-button>
        </b-form>
    </div>
</template>

<script>
import UserApiService from "../../services/user_api_service";
import User from "../../models/user";

export default {
    name: "ProfileUserComponent",
    
    data() {
        return {
            loading: true,
            user: null,
            editEnabled: false,
            form: {
                password: '',
                repeat_password: ''
            },
        };
    },
    computed: {
        enableSubmitButton() {
            return true;
        },
        passwordValidation() {
            return (this.form.password == this.form.repeat_password) 
        }
    },
    methods: {
        async fetchUser() {
            this.loading = true;
            try {
                const data = await UserApiService.get_me();
                this.user = new User(data.data);
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        async deleteUser() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_delete_profile'), 
                {
                    okTitle: this.$t('text.delete_user'),
                    cancelTitle: this.$t('text.cancel'),
                    okVariant: 'danger',
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    try {
                        await UserApiService.delete(this.user.id);
                        this.loading = false;
                        this.logout();
                    } catch (error) {
                        this.loading = false;
                    }
                }
            })
        },
        async updateUser() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_update_profile'), 
                {
                    okTitle: this.$t('text.save'),
                    cancelTitle: this.$t('text.cancel'),
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    this.user.email = this.user.email.replaceAll(" ", "")
                    var payload = this.user.toDict()
                    if (this.form.password != null && this.form.password != "") {
                        payload['password'] = this.form.password
                    }
                    try {
                        await UserApiService.patch(this.user.id, payload);
                        this.loading = false;
                        this.editEnabled = false;
                        this.makeToast(
                            "success",
                            this.$t('text.saved'),
                            ""
                        );
                    } catch (error) {
                        var errorString = this.$t("text.something_went_wrong_try_later")
                        if (error.response.status === 400) {
                            errorString = ""
                            for (var key in error.response.data) {
                                errorString += error.response.data[key][0]
                                errorString += " "
                            }
                        }
                        this.$bvModal.msgBoxOk(errorString, {okVariant: 'danger'})
                        this.loading = false;
                    }
                }
            })
        },
        logout: function() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/");
            });
        },
        onSubmit(event) {
            event.preventDefault()
            if (this.editEnabled) {
                this.updateUser()
            } else {
                this.editEnabled = true
            }
        },
        makeToast(variant = null, title, body) {
            this.$bvToast.toast(body, {
                title: title,
                toaster: "b-toaster-top-center",
                variant: variant,
                solid: true
            });
        },
    },
    created() {
        this.fetchUser();
    },

};
</script>

<style scoped>
.body-container {
    text-align: left;
    margin: auto;
    width: 100%;
}

.submit-button {
    float:right;
}

.link-button {
    margin-left:20px;
    color: #007bff;
}
</style>
